var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextAlignmentRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/TextAlignment/Right/20px",
    fill: "#D8D8D8",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.5,
    y: 5.5,
    width: 13,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 6.5,
    y: 8.5,
    width: 11,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 10.5,
    y: 11.5,
    width: 7,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 6.5,
    y: 14.5,
    width: 11,
    height: 1,
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignmentRight);
export default __webpack_public_path__ + "static/media/text-alignment-right.350d51e4720078ee6f70987256b8831b.svg";
export { ForwardRef as ReactComponent };